export default "__VITE_ASSET__D9y0w7CJ__"